// extracted by mini-css-extract-plugin
export default {"topNav":"TopNavOverride_topNav__jtJK4","spindlLogo":"TopNavOverride_spindlLogo__UCrqR"};